import { useState } from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '@/components/feature/LanguageSwitcher';

const Footer = () => {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      setFormMessage('Mensagem enviada com sucesso! Entraremos em contato em breve.');
      form.reset();
      return;
    }

    formData.delete('phone_alt');
    setFormStatus('idle');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, String(value));
      });

      const response = await fetch('https://readdy.ai/api/form/d96gh9ltfb6ioa7s1o40', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = {}; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('Mensagem enviada com sucesso! Entraremos em contato em breve.');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setFormStatus('error');
        setFormMessage(serverMsg || 'Erro ao enviar. Tente novamente.');
      }
    } catch {
      setFormStatus('error');
      setFormMessage('Erro de conexão. Tente novamente.');
    }
  };

  return (
    <>
      {/* ─── Formulário de Contato ─── */}
      <section className="bg-gradient-to-b from-white to-gray-50 py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              Prefere que o Daniel Carvalho Imobiliário entre em contato com você?
            </h2>
            <p className="text-foreground-600 text-base">
              Preencha seus dados abaixo e retornaremos em breve.
            </p>
          </div>

          <form
            data-readdy-form
            onSubmit={handleFormSubmit}
            className="space-y-6"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="footer-nome" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  Nome
                </label>
                <input
                  id="footer-nome"
                  name="nome"
                  type="text"
                  required
                  placeholder="Seu nome"
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-foreground-950 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 transition-all text-sm"
                />
              </div>
              <div>
                <label htmlFor="footer-sobrenome" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  Sobrenome
                </label>
                <input
                  id="footer-sobrenome"
                  name="sobrenome"
                  type="text"
                  required
                  placeholder="Seu sobrenome"
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-foreground-950 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 transition-all text-sm"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="footer-telefone" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  Telefone
                </label>
                <input
                  id="footer-telefone"
                  name="telefone"
                  type="tel"
                  required
                  placeholder="(XX) XXXXX-XXXX"
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-foreground-950 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 transition-all text-sm"
                />
              </div>
              <div>
                <label htmlFor="footer-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  Email
                </label>
                <input
                  id="footer-email"
                  name="email"
                  type="email"
                  required
                  placeholder="seu@email.com"
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 bg-white text-foreground-950 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500/30 focus:border-teal-500 transition-all text-sm"
                />
              </div>
            </div>

            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="contact-phone_alt-field"
            />

            <div className="text-center">
              <button
                type="submit"
                disabled={formStatus === 'success'}
                className="whitespace-nowrap px-8 py-3.5 bg-teal-600 hover:bg-teal-700 disabled:bg-teal-400 text-white font-semibold rounded-lg transition-colors cursor-pointer text-sm"
              >
                {formStatus === 'idle' ? 'Enviar' : 'Enviando...'}
              </button>
            </div>

            {formStatus !== 'idle' && (
              <p className={`text-center text-sm font-medium ${formStatus === 'success' ? 'text-teal-600' : 'text-red-500'}`}>
                {formMessage}
              </p>
            )}
          </form>
        </div>
      </section>

    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo e Descrição */}
          <div>
            <img
              src="https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/3c37db76e3e907da977a289ded40f172.png"
              alt="Daniel Carvalho Imobiliário"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 text-base leading-relaxed mb-4">
              Soluções completas em venda, compra, aluguel, financiamento e serviços imobiliários. Realizando sonhos desde 2017.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.youtube.com/@DanielCarvalhoImobiliario"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/danielcarvalhoimobiliario"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/danielcarvalhoimobiliario/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/daniel-carvalho-serviços-imobiliários-ltda-85b130275/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-lg font-bold mb-4">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-teal-400 transition-colors text-base">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-300 hover:text-teal-400 transition-colors text-base">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-gray-300 text-base">
                <i className="ri-phone-fill text-teal-400"></i>
                <span>(11) 9-2230-5730</span>
              </li>
              <li>
                <a
                  href="https://wa.me/5511922305730?text=Olá,%20Daniel.%20Cheguei%20aqui%20através%20do%20seu%20site.%20Você%20pode%20me%20ajudar?"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-300 hover:text-teal-400 transition-colors text-base"
                >
                  <i className="ri-whatsapp-fill text-teal-400"></i>
                  <span>WhatsApp</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-base">
            © {new Date().getFullYear()} Daniel Carvalho Serviços Imobiliários. Todos os direitos reservados.
          </p>
          <LanguageSwitcher />

        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
